import React, { useState, useRef, useEffect } from 'react';
import PdfViwer from '../../common/components/GlobalPDFViewer/GlobalPdfViewer';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
const pdf = '/images/icons/CmDashIcons/pdf.svg';
import styles from './CMDashboard.module.css';
import Modal from '../../common/components/Modal/modal';
const BackImage = '/images/icons/CmDashIcons/back.svg';
import ShowDoc from './ShowDoc';

const { widthFit } = styles;
const CMDashboardIncomeData = ({
  updateTrigger,
  setUpdateTrigger,
  fileTitle,
  docId,
  setFullImage,
  setIsError,
  tag,
  verified,
  isError,
  setFile,
  file
}) => {
  const [errorOcc, setErrorState] = useState(false);
  const [show, setShow] = useState(false);

  return (
    <div className="w-full">
      <div
        className="bg-grey-1007 px-7 py-7 border border-grey-1006 rounded border-dashed mt-3 cursor-pointer w-40"
        style={{ height: '130px' }}
        onClick={() => {
          setFile(file), setIsError(errorOcc), setShow(true);
        }}
      >
        <img
          className={`w-20 h-12 mx-auto`}
          src={file}
          onError={e => {
            e.target.onerror = null;
            e.target.src = pdf;
            e.target.className = 'w-12 mx-auto';
            setErrorState(true);
          }}
          alt="pdf"
        />
      </div>
      <div className={`flex text-center ${widthFit} mx-auto my-2 items-center`}>
        <p className="font-normal font-roboto text-sm text-black-1013 mr-2 capitalize">
          {tag}
        </p>
        <div className="flex">
          {verified != null ? (
            verified ? (
              <CheckCircleIcon style={{ color: 'green', width: '18px' }} />
            ) : (
              <CancelIcon style={{ color: 'red', width: '18px' }} />
            )
          ) : null}
        </div>
      </div>
      {show && (
        <ShowDoc
          income
          updateTrigger={updateTrigger}
          setUpdateTrigger={setUpdateTrigger}
          fileTitle={fileTitle}
          docId={docId}
          verified={verified}
          setShow={setShow}
          show={show}
          file={file}
          setIsError={setIsError}
          isError={errorOcc}
        />
      )}
    </div>
  );
};

export default CMDashboardIncomeData;
